var _path, _path2, _rect, _rect2, _rect3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 25,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M9.4 10.3H11.2l.3.3 1 1 1-1 .3-.3H15.6c.8 0 1.4-.6 1.4-1.3V2.3c0-.7-.6-1.3-1.4-1.3H9.4C8.6 1 8 1.6 8 2.3V9c0 .8.6 1.3 1.4 1.3zM14 2h1v7.2h-1V2zm-2 0h1v7.2h-1V2zm-2 0h1v7.2h-1V2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#102633",
  d: "M9.4 11.3h1.4l1.7 1.7 1.7-1.7h1.4c1.3 0 2.4-1 2.4-2.3V2.3C18 1 16.9 0 15.6 0H9.4C8.1 0 7 1 7 2.3V9c0 1.3 1.1 2.3 2.4 2.3zM8 2.3C8 1.6 8.6 1 9.4 1h6.2c.8 0 1.4.6 1.4 1.3V9c0 .7-.6 1.3-1.4 1.3H13.8l-.3.3-1 1-1-1-.3-.3H9.4C8.6 10.3 8 9.8 8 9V2.3zM8.9 17H0v3h8.9c-.2-.5-.3-1-.3-1.5s.1-1 .3-1.5zM16.1 17c.2.5.3 1 .3 1.5s-.1 1-.3 1.5H25v-3h-8.9z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.2,
  x: 14,
  y: 2,
  fill: "#102633"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.2,
  x: 12,
  y: 2,
  fill: "#102633"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 7.2,
  x: 10,
  y: 2,
  fill: "#102633"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 18.5,
  r: 2.6,
  fill: "#102633"
})));
export default SvgIconSlider;